import { ChatMessageItem } from "../types";
import { ChatEvent } from "../store";
import { useAllSession } from "./useAllSession";

export function useUpdateMessage() {
    const { sessions, findMessage } = useAllSession();

    // 修改消息内容
    function updateMessage(
        sessionId: string,
        messageId: string,
        data: Partial<ChatMessageItem>
    ) {
        const session = sessions.find(item => item.guid === sessionId);
        if (!session) return;

        const index = session.chatMessages.findIndex(
            item => item.guid === messageId
        );

        if (index === -1) return;
        Object.assign(session.chatMessages[index], data);
        ChatEvent.emit("MessageUpdate", { id: messageId });
    }

    // 添加消息
    function addMessage(sessionId: string, message: ChatMessageItem) {
        const session = sessions.find(item => item.guid === sessionId);
        if (!session) return;
        if (!session.chatMessages) session.chatMessages = [];
        session.chatMessages.push(message);
        ChatEvent.emit("SessionUpdate", { id: sessionId });
    }

    // 删除消息
    function removeMessage(sessionId: string, messageId: string) {
        const session = sessions.find(item => item.guid === sessionId);
        if (!session) return;

        const index = session.chatMessages.findIndex(
            item => item.guid === messageId
        );

        if (index === -1) return;

        session.chatMessages.splice(index, 1);
        ChatEvent.emit("SessionUpdate", { id: sessionId });
    }

    // 查找session是不是已经存在于列表
    function checkMessageExist(sessionId: string, messageId: string) {
        return !!findMessage(sessionId, messageId);
    }

    return {
        addMessage,
        updateMessage,
        removeMessage,
        checkMessageExist
    };
}
